// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A4su","top":"styles_top__1zCgt"};